import { uuid as uuid } from 'vue3-uuid'; // Import the uuid function
import {defineStore} from 'pinia';
import {useSecurityStore} from './dsecurity';

let webSocket = null;
var websocketRetryTimeout;
var project_name = process.env.VUE_APP_PROJECT_NAME;
const websocket_localstorage_key = project_name + "_websocket";

export const useWebSocketStore = defineStore("websocket", {    
    state: () => ({
        id: null,
        connected: false,
        connecting: false,
        keepid: true,
        customparamas: {}, // { key: value}
        message: null, // { type: null, data: null}
    }),

    // getters: {
    //     id() {
    //         return this.id;
    //     },
    //     connected() {
    //         return this.connected;
    //     },
    //     connecting() {
    //         return this.connecting;
    //     },
    //     message() {
    //         return this.message;
    //     },
    // },

    actions: {        
        async connect() {                        
            const secStore = useSecurityStore();
            
            // try get Id
            var storage_id = localStorage.getItem(websocket_localstorage_key);
            if(storage_id && this.keepid)
                this.id = storage_id;
            else {
                this.id = uuid.v4();
                localStorage.setItem(websocket_localstorage_key, this.id);
            }

            var self = this;

            // Check if browser can detect internet connection
            if (!window.navigator.onLine) {
                // Skip connection if no internet detected and try again in a moment
                //console.error("No internet connection detected, will skip connecting to WebSocket and try again in a moment...");
                clearTimeout(websocketRetryTimeout);
             
                websocketRetryTimeout = setTimeout(() => {
                    //self.connect(); // reconnect
                }, 500);
                return;
            }

            if (this.connected) {
                // Skip connect if connection is already made
                return;
            }

            if (!("WebSocket" in window)) {
                // The browser doesn't support WebSocket
                console.error("WebSocket NOT supported by your Browser!");
                return;
            }

            // console.log("running connect()...");
           this.connecting = true;
            //console.log("id->", this.id);
            var token = secStore.token;
            if(!token)
            token = "notoken";
            
            let websocketUrl = process.env.VUE_APP_WEBSOCKET_URL + "?id=" + this.id + "&AuthorizationToken=" + token;
            for(var key in this.customparamas){
                websocketUrl += "&" + key + "=" + this.customparamas[key];
            }

            //console.log("websocket URL->", websocketUrl);
            webSocket = new WebSocket(websocketUrl);

            webSocket.onopen = function () {
                //console.log("WebSocket is connected. event->", event);
                self.connected = true;
                self.connecting = false;
            }

            webSocket.onclose = function () {
                //console.log("WebSocket connection have been closed. event->", event);
                self.connected = false;

                clearTimeout(websocketRetryTimeout);
                websocketRetryTimeout = setTimeout(() => {
                    //self.connect();
                }, 500);
            };

            webSocket.onerror = function (event) {
                console.error("Websocket error->", event);
            };            
            webSocket.onmessage = function (event) {
                // console.log("Websocket message received. event->", event);
                var json_message = JSON.parse(event.data);
                //console.log("message->", json_message);
                self.message = json_message;
            }

            // Force close websocketconnection. Reconnect logic will trigger
            // setTimeout(() => {
            //     webSocket.close();
            // }, 5000);
        },
        async reconnect() {
            //console.log("running reconnect()...");
            if (this.connected) {
                // console.log("closing websocket...");
                webSocket.onclose = function () { }; // disable onclose handler first
                webSocket.close();
                this.connected = false;
            }
            this.connect();
        },        
    }    
})
